
import { DossierConfigService } from "@/services/dossier-config-service";
import AppSaleSearchBrowse from "@/components/sales/SaleSearchBrowse.vue";
import { IOpenClientData } from "@/utils/chart-open";
import Vue from "vue";
import { View } from "@/models/view";
import { ViewColumn } from "@/utils/views/view-column";
import { HumanFilter } from "@/utils/human-filter";
import { getModel } from "@/utils/models/model";
import { printHumanFloatDashboard } from "@/utils/pretty-print";
import {ChartService} from "@/services";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardChartData } from "@/utils/dashboard/dashboard-chart-data";

export default Vue.extend({
	data(){
		return {
			showOpenBrowse: false,
			selectedContact: 0,
			open: [] as IOpenClientData[]
		};
	},
	props: {
		showPrevYear: Boolean,
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		startMonth():number {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth;
		},
		view():View {
			let v = new View();
			v.Table = "Sale";
			v.BrowseID = 6;
			v.Columns = this.viewColumns;
			v.HumanFilters = [new HumanFilter({Field: "this.ContactID", Operator: "=", Values: [`${this.selectedContact}`]})];
			return v;
		},
		viewColumns():ViewColumn[]{
			let model = getModel("Sale");
			return [
				ViewColumn.makeQuickViewColumn("InvoiceDate", model, "100px", this.$ct("common.date.date")),
				ViewColumn.makeQuickViewColumn("ExpirationDate", model, "100px"),
				ViewColumn.makeQuickViewColumn("ComputedFriendlyID", model, "100px"),
				ViewColumn.makeQuickViewColumn("InvoiceAddress.CompanyOrFullName", model, "250px", this.$ct("common.name")),
				ViewColumn.makeQuickViewColumn("TotalExcVAT", model, "140px"),
				ViewColumn.makeQuickViewColumn("TotalIncVAT", model, "140px"),
				ViewColumn.makeQuickViewColumn("TotalOpen", model, "140px"),
				ViewColumn.makeQuickViewColumn("Status", model, "140px")
			];
		}
	},

	methods: {
		async fetch() {
			let data = this.item.Data as DashboardChartData;
			this.open = await ChartService.getOpenClients(data.filters, data.getBookYearOverrideValue());
		},
		showOpen(id:number){
			this.selectedContact = id;
			this.showOpenBrowse = true;
		},
		humanFloat(val:number):string{
			return printHumanFloatDashboard(val);
		}
	},
	async mounted() {
		this.fetch();
	},
	components: {
		AppSaleSearchBrowse,
	},
	i18nEx: {
		componentPrefix: "components.charts-OpenChart"
	}
});
